import { StackView, Spinner } from '@planningcenter/tapestry-react';
import React from 'react';
import { DrawerHeader } from '../vendor/topbar/components/drawer_header.js';
import { DrawerHeading } from '../vendor/topbar/components/drawer_heading.js';
import { BetaBadge } from './beta_badge.js';

const BlankStateView = () => {
    return (React.createElement(DrawerHeader, null,
        React.createElement(StackView, { alignment: "center", axis: "horizontal", spacing: 1 },
            React.createElement(DrawerHeading, null, "Chat"),
            React.createElement(BetaBadge, null),
            React.createElement(Spinner, { color: "hsl(0 0% 62%)", thickness: 2, trackColor: "hsl(0 0% 97%)" }))));
};

export { BlankStateView };
//# sourceMappingURL=blank_state_view.js.map
